import { AwsConfig as AwsConstants } from './Constants';

import { IRole } from '../interfaces/IRole';
import BaseService, { RequestInterface } from './Base';
import { IUser } from '@interfaces/IUser';


export default class RoleService extends BaseService {
    constructor () {
        super(AwsConstants.API_CONFIG, 'role');
    }
    async listAll (fields?: string[]): Promise<IRole[]> {
        const params: RequestInterface = {
            queryStringParameters: super.setFields(fields)
        };

        const res = await super.get<IRole[]>('', params);
        return res;
    }

    async roleAdd (id: string, data: string): Promise<IUser> {
        const params: RequestInterface = {
            body: data
        };
        const res = await super.put<IUser>(`user/${id}`, params);
        return res;
    }

    async getById (id: string, fields?: string[]): Promise<IRole> {
        const params: RequestInterface = {
            queryStringParameters: super.setFields(fields)
        };
        const res = await super.get<IRole>(id, params);
        return res;
    }

    async roleRemove (unitId: string, roleId: string): Promise<void> {
        await super.delete<void>(`user/${unitId}/role/${roleId}`);
    }

}